import RpcService             from '@/core/services/Rpc/RpcService';

import type RpcResponse       from '@/core/services/Rpc/RpcResponse';
import type Package           from '@/domains/Packages/Package';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';


class PackagesDAO {

	static async getList(
		filters?: {
			id?:        number;
			pattern?:   string;
			code?:      string;
			name?:      string;
			isDeleted?: boolean;
		},
		pagination?: RpcDataPagination,
		sort?:       RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest('packages.getList', filters, pagination, sort);
	}

	static async add(pkg: Package): Promise<RpcResponse> {
		return await RpcService.makeRequest('packages.add', { package: pkg });
	}

	static async update(pkg: Package): Promise<RpcResponse> {
		return await RpcService.makeRequest('packages.update', { package: pkg });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('packages.delete', { id });
	}
}

export default PackagesDAO;
